import { Base_Url } from "../../Base Url/BaseUrl";
import { postApiWithAuthenticated, getListWithAuthenticated} from "../../Api Method/ApiMethod";


const MasterBlogBaseUrl = `${Base_Url}/career`;


export const careerList = async (params) => {
  let url = `${MasterBlogBaseUrl}/careerList`;

  const res = await postApiWithAuthenticated(url, params);
  return res;
};


export const addUpdateCareer = async (url = '', params) => {
    
  
    const res = await postApiWithAuthenticated(`${MasterBlogBaseUrl}${url}`, params);
    return res;
  };


export const changeCareerStatus = async (id) => {
  let url = `${MasterBlogBaseUrl}/changeCareerStatus?careerKeyID=${id}`;
  const res = await getListWithAuthenticated(url);
  return res;
};
export const careerListWebsite = async (id) => {
  let url = `${MasterBlogBaseUrl}/careerListWebsite`;
  const res = await getListWithAuthenticated(url);
  return res;
};


export const GetCareerModelData = async (id) => {
    let url = `${MasterBlogBaseUrl}/GetCareerModel?careerKeyID=${id}`;
  
    const res = await getListWithAuthenticated(url);
    return res;
  };
export const positionLookupList = async (id) => {
    let url = `${MasterBlogBaseUrl}/positionLookupList`;
  
    const res = await getListWithAuthenticated(url);
    return res;
  };
export const getBlogForWebsite = async (id) => {
    let url = `${MasterBlogBaseUrl}/getBlogForWebsite?blogKeyID=${id}`;
  
    const res = await getListWithAuthenticated(url);
    return res;
  };


